import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { IAccelerationTaskInfo } from '../../ts/models/IAccelerationTaskInfo';
import { IListResource } from '../../ts/resources/Resource';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { DeleteDataAccelerationTasksRequest } from '../../ts/ServerApi/dataAcceleration/DeleteDataAccelerationTasksRequest';
import { RunDataAccelerationTasksRequest } from '../../ts/ServerApi/dataAcceleration/RunDataAccelerationTasksRequest';
import { GetAccelerationTasksRequest } from '../../ts/ServerApi/requests/GetAccelerationTasksRequest';
import { AccelerationNeedsScheduleRequest, IAccelerationNeedsScheduleResult } from '../serverApi/requests/AccelerationNeedsScheduleRequest';
import { SetDataAccelerationTasksScheduleRequest } from '../serverApi/requests/SetDataAccelerationTasksScheduleRequest';

class AccelerationTasksResource implements IListResource<IAccelerationTaskInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetAccelerationTasksRequest, ServerApiMapper.accelerationTasks);

  public all(): ResourceQuery<IAccelerationTaskInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public run(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunDataAccelerationTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public del(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteDataAccelerationTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public needsSchedule(ids: string[]): Promise<IAccelerationNeedsScheduleResult> {
    return WebHttpClient.sendRequest(new AccelerationNeedsScheduleRequest({targetIds: ids}));
  }

  public setSchedule(ids: string[], scheduleId: string) {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetDataAccelerationTasksScheduleRequest(idsBlock, scheduleId)),
      ResultHelper.combineResults);
  }
}

export const AccelerationTasks = new AccelerationTasksResource();


